<template>
  <div class="app-single-top-up-wrapper">
    <slot name="txtBefore"></slot>
    <slot name="txtNoPayment" v-if="!isPaymentSet"></slot>
    <SingleTopUpAmountInput
      v-if="showAmountSelector && isPaymentSet"
      :amounts="amounts"
      :next-step="'confirm'"
    >
      <template v-for="slot in possibleChildSlotsFor('Input')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SingleTopUpAmountInput>
    <SingleTopUpConfirm
      v-if="showConfirmation  && isPaymentSet"
      :payment="singleTopUpStatus.payment"
      :payment-type="true"
    >
      <template v-for="slot in possibleChildSlotsFor('Confirm')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SingleTopUpConfirm>
    <Success
      v-if="showSuccess  && isPaymentSet"
      :show-logout="true"
    >
      <template v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Success>
    <slot name="txtAfter"></slot>
  </div>
</template>
<script>

import { wrapQuery } from '../../../../../../helper/wrapGQLQuery'
import gql from 'graphql-tag'
import SingleTopUpAmountInput, { stepName as selector } from '../AmountInput.vue'
import SingleTopUpConfirm, { stepName as confirm } from '../Confirm.vue'
import Success, { stepName as success } from '../Success.vue'
import { mapGetters } from 'vuex'
import transaction from '@/mixins/transaction'
import slotProxy from '../../../../../../mixins/slotProxy'
import extraData from '../../../../../../mixins/extraData'

export default {
  name: 'SingleTopUpWrapper',
  components: { Success, SingleTopUpConfirm, SingleTopUpAmountInput },
  data () {
    return {
      singleTopUpStatus: {
        directPossible: false,
        payment: {}
      }
    }
  },
  props: {
    amounts: {
      type: Object,
      default: function () {
        return {
          min: 10,
          max: 40,
          step: 1
        }
      }
    }
  },
  computed: {
    ...mapGetters('topUp/single', [
      'currentStep'
    ]),
    showAmountSelector () {
      return this.currentStep === selector
    },
    showConfirmation () {
      return this.currentStep === confirm
    },
    showSuccess () {
      return this.currentStep === success
    },
    isPaymentSet () {
      return this.singleTopUpStatus.directPossible
    }
  },
  mixins: [
    transaction('singleTopUp'),
    slotProxy(),
    extraData()
  ],
  apollo: {
    singleTopUpStatus: function () {
      return wrapQuery(
        gql`query singleTopUp {
          singleTopUpStatus {
            directPossible
            payment {
              ...on BankAccount {
                type
                iban
                owner
              }
              ...on CreditCard {
                type
                holder
                company
                expiryMonth
                expiryYear
                lastDigits
              }
            }
          }
        }`, this, 'singleTopUpStatus', {}, null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  }
}
</script>
